import React from "react";
import styles from "../../../views/DetailMDR/DetailMDR.module.css";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { VscPreview } from "react-icons/vsc";

const HeaderMDRCompany = ({ data }) => {
  const changeColoResult = () => {
    if (data.RiskCompany.data === "Riesgo bajo") {
      return <p className={styles.mdrlow}>{data.RiskCompany.data}</p>;
    } else if (data.RiskCompany.data === "Riesgo medio") {
      return <p className={styles.mdrmid}>{data.RiskCompany.data}</p>;
    } else {
      return <p className={styles.mdrheig}>{data.RiskCompany.data}</p>;
    }
  };
  return (
    <div className={styles.header}>
      {!data ? (
        <NotReportViewData title="Informe de Matriz" Icon={VscPreview} />
      ) : (
        <>
          <div className={styles.lineBotton}>
            <h2 className={styles.title}>
              <p className={styles.ptittle}>{data.cuit + " / "}</p>
              <p className={styles.ptittle}>{data.companyName}</p>
              {changeColoResult()}
            </h2>
          </div>
          <div className={styles.info}>
            <div className={styles.infoTitle}>
              <p>Datos de la busqueda</p>
            </div>
            <div className={styles.infoSubTitle}>
              <p>Datos ingresados: </p>
            </div>
            <div className={styles.infoRows}>
              <div className={styles.infoRow}>
                <p className={styles.datainfo}>
                  Calle:
                  <span
                    style={{
                      color: "#6f6f6f",
                      fontsize: "1em",
                      margin: "0px 10px",
                      fontfamily: "sans-serif",
                      fontweight: "600 ",
                    }}
                  >
                    {data.street}
                  </span>
                </p>
                <p className={styles.datainfo}>
                  Número:
                  <span
                    style={{
                      color: "#6f6f6f",
                      fontsize: "1em",
                      margin: "0px 10px",
                      fontfamily: "sans-serif",
                      fontweight: "600 ",
                    }}
                  >
                    {data.numberStreet}
                  </span>
                </p>
              </div>
              <div className={styles.infoRow}>
                <p className={styles.datainfo}>
                  Piso/Departamento:
                  <span
                    style={{
                      color: "#6f6f6f",
                      fontsize: "1em",
                      margin: "0px 10px",
                      fontfamily: "sans-serif",
                      fontweight: "600 ",
                    }}
                  >
                    {data.apart} {data.floor}
                  </span>
                </p>
                <p className={styles.datainfo}>
                  CP:
                  <span
                    style={{
                      color: "#6f6f6f",
                      fontsize: "1em",
                      margin: "0px 10px",
                      fontfamily: "sans-serif",
                      fontweight: "600 ",
                    }}
                  >
                    {data.postalCode}
                  </span>
                </p>
              </div>
              <div className={styles.infoRow}>
                <p className={styles.datainfo}>
                  Localidad:
                  <span
                    style={{
                      color: "#6f6f6f",
                      fontsize: "1em",
                      margin: "0px 10px",
                      fontfamily: "sans-serif",
                      fontweight: "600 ",
                    }}
                  >
                    {data.location}
                  </span>
                </p>
                <p className={styles.datainfo}>
                  Provincia:
                  <span
                    style={{
                      color: "#6f6f6f",
                      fontsize: "1em",
                      margin: "0px 10px",
                      fontfamily: "sans-serif",
                      fontweight: "600 ",
                    }}
                  >
                    {data.province}
                  </span>
                </p>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default HeaderMDRCompany;
